import { supabase } from '../lib/supabase';
export class QuickNotesService {
    static TABLE_NAME = 'quick_notes';
    /**
     * Get or create quick note for current user
     */
    static async getNote(userId) {
        try {
            const { data, error } = await supabase
                .from(this.TABLE_NAME)
                .select('*')
                .eq('user_id', userId)
                .single();
            if (error && error.code !== 'PGRST116') {
                // PGRST116 means no rows found, which is expected for new users
                console.error('Failed to get quick note:', error);
                return null;
            }
            if (!data) {
                return null;
            }
            return {
                id: data.id,
                userId: data.user_id,
                content: data.content,
                createdAt: new Date(data.created_at),
                updatedAt: new Date(data.updated_at),
            };
        }
        catch (error) {
            console.error('Failed to get quick note from Supabase:', error);
            return null;
        }
    }
    /**
     * Save or update quick note
     */
    static async saveNote(userId, content) {
        try {
            // Try to update first
            const { data: existingNote } = await supabase
                .from(this.TABLE_NAME)
                .select('id')
                .eq('user_id', userId)
                .single();
            if (existingNote) {
                // Update existing note
                const { error } = await supabase
                    .from(this.TABLE_NAME)
                    .update({
                    content,
                    updated_at: new Date().toISOString(),
                })
                    .eq('user_id', userId);
                if (error) {
                    console.error('Failed to update quick note:', error);
                    return false;
                }
            }
            else {
                // Insert new note
                const { error } = await supabase
                    .from(this.TABLE_NAME)
                    .insert({
                    user_id: userId,
                    content,
                    created_at: new Date().toISOString(),
                    updated_at: new Date().toISOString(),
                });
                if (error) {
                    console.error('Failed to insert quick note:', error);
                    return false;
                }
            }
            return true;
        }
        catch (error) {
            console.error('Failed to save quick note to Supabase:', error);
            return false;
        }
    }
    /**
     * Delete quick note
     */
    static async deleteNote(userId) {
        try {
            const { error } = await supabase
                .from(this.TABLE_NAME)
                .delete()
                .eq('user_id', userId);
            if (error) {
                console.error('Failed to delete quick note:', error);
                return false;
            }
            return true;
        }
        catch (error) {
            console.error('Failed to delete quick note from Supabase:', error);
            return false;
        }
    }
}
